import * as z from 'zod';

export type PaymentAllocationFormSchemaValues = z.infer<typeof paymentAllocationFormSchema>;
export const paymentAllocationFormSchema = z.object({
    amount: z.number().int().min(0),
    payment: z.string().optional(),
    financial_document: z.string().optional(),
});
